import React from 'react';
import { Divider, Grid, List, ListItem, Paper } from '@mui/material';

import { MultiValueBooleanInput } from '../../multi-value-controls/MultiValueBooleanInput';
import { MultiValueFeetDistanceInput } from '../../multi-value-controls/MultiValueFeetDistanceInput';
import { MultiValueNumberInput } from '../../multi-value-controls/MultiValueNumberInput';
import { LoadSettingsControlProps } from '../LoadSettingsControls';
import { emphasizedControl } from './emphasizedControl';

export function FloorTCLiveSettings({ disabled, loadSettingsArray, setLoadSettingsValues }: LoadSettingsControlProps) {
  return (
    <>
      <Grid size={6}>
        <MultiValueNumberInput
          values={loadSettingsArray.map((loadSettings) => loadSettings.floorTopChordLiveLoad)}
          submit={(floorTopChordLiveLoad) => setLoadSettingsValues({ floorTopChordLiveLoad })}
          label="TC Live Load"
          unit="psf"
          disabled={disabled}
        />
      </Grid>

      <Grid size={6}>
        <MultiValueBooleanInput
          values={loadSettingsArray.map((loadSettings) => loadSettings.considerUnbalancedFloorLiveLoad)}
          onChange={(considerUnbalancedFloorLiveLoad) => setLoadSettingsValues({ considerUnbalancedFloorLiveLoad })}
          label="Consider Unbalanced"
          disabled={disabled}
        />
      </Grid>

      <Grid size={12}>
        <Paper sx={emphasizedControl}>
          <List dense>
            <ListItem>
              <MultiValueBooleanInput
                values={loadSettingsArray.map((loadSettings) => loadSettings.considerMovingOfficeLoad)}
                onChange={(considerMovingOfficeLoad) => setLoadSettingsValues({ considerMovingOfficeLoad })}
                label="Consider Moving Office Load"
                disabled={disabled}
              />
            </ListItem>
            {loadSettingsArray.some((loadSettings) => loadSettings.considerMovingOfficeLoad) && (
              <>
                <ListItem>
                  <MultiValueNumberInput
                    values={loadSettingsArray.map((loadSettings) => loadSettings.movingOfficeLoad)}
                    submit={(movingOfficeLoad) => setLoadSettingsValues({ movingOfficeLoad })}
                    label="Moving Office Load"
                    unit="lbs"
                    disabled={disabled}
                  />
                </ListItem>
                <ListItem>
                  <MultiValueFeetDistanceInput
                    values={loadSettingsArray.map((loadSettings) => loadSettings.movingOfficeLoadLength)}
                    submit={(movingOfficeLoadLength) => setLoadSettingsValues({ movingOfficeLoadLength })}
                    label="Moving Office Load Length"
                    disabled={disabled}
                  />
                </ListItem>
              </>
            )}
          </List>
        </Paper>
      </Grid>
      <Grid size={12}>
        <Divider />
      </Grid>
    </>
  );
}
